/*
  Cart drawer footer controller.

  When the line items list overflows (scrollbar appears), the summary panel
  collapses to a compact mode: only the checkout button and payment icons stay
  visible, giving the items list more room. When everything fits again the
  full summary (subtotal / shipping / total) comes back.

  The overflow check always measures against the EXPANDED footer (via the
  transition-less `cart-summary--measure` class), so the toggle can never
  oscillate between the two states.
*/

(() => {
  const COMPACT_CLASS = 'cart-summary--compact';
  const MEASURE_CLASS = 'cart-summary--measure';

  const init = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    let scheduled = false;

    const check = () => {
      scheduled = false;

      const items = drawer.querySelector('cart-drawer-items');
      const summary = drawer.querySelector('.cart-summary');
      if (!items || !summary || items.classList.contains('is-empty')) return;

      // Measure with the footer fully expanded and transitions off; reading
      // scrollHeight forces a reflow, nothing paints in between.
      summary.classList.add(MEASURE_CLASS);
      const overflows = items.scrollHeight > items.clientHeight + 2;
      summary.classList.remove(MEASURE_CLASS);

      summary.classList.toggle(COMPACT_CLASS, overflows);
    };

    const scheduleCheck = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(check);
    };

    // Cart updates replace parts of the drawer's DOM (innerHTML/replaceWith).
    new MutationObserver(scheduleCheck).observe(drawer, { childList: true, subtree: true });
    // Cart note <details> opening/closing changes the footer height.
    drawer.addEventListener('toggle', scheduleCheck, true);
    window.addEventListener('resize', scheduleCheck);

    scheduleCheck();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
